<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>palette</md-icon>
          </div>
          <h4 class="title">Create New Workshop</h4>
        </md-card-header>

        <md-card-content>
          <md-field>
            <label>Title</label>
            <md-input v-model="title" type="text"></md-input>
          </md-field>
          <md-field>
            <md-datepicker v-model="date">
            <label>Select date</label>
          </md-datepicker>
          </md-field>
          <md-field>
            <label>Time</label>
            <md-input v-model="time" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Address</label>
            <md-input v-model="address" type="text"></md-input>
          </md-field>
          <md-field>
            <label>Registratin Fees</label>
            <md-input v-model="price" type="number"></md-input>
          </md-field>
        </md-card-content>

        <md-card-actions md-alignment="left">
          <md-button class="md-success" :disabled="isDisabled" @click="createWorkshop()">
            Create <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>
<script>
import WorkshopService from "../../../services/WorkshopService";
export default {
  components: {},
  data() {
    return {
      isDisabled: false,
      title: "",
      date:"",
      time:"",
      address: "",
      price: 0,
    };
  },
  methods: {
    async createWorkshop() {
      this.isDisabled = true;
      let data = {
        title: this.title,
        date: this.date,
        time: this.time,
        address: this.address,
        price: this.price,
        slug: this.title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '') // remove invalid chars
        .replace(/\s+/g, '-')         // replace spaces with -
        .replace(/-+/g, '-')         // collapse multiple -
      }
      await WorkshopService.createWorkshop(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.$router.push('workshops');
        }).catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
        });
    },
  },
  beforeMount() {
  }
};
</script>
<style lang="scss" scoped>
.md-card .md-card-actions {
  border: none;
}

.md-inline-checkboxes {
  display: inline-flex;

  .md-checkbox {
    margin-top: 15px !important;
  }
}

.md-checkbox,
.md-radio {
  margin-top: 15px;
  margin-bottom: 0.5rem;
}

.md-checkbox,
.md-radio {
  display: flex;
}

.md-radio .md-radio-container {
  margin-left: 5px;
  position: relative;
  left: -3px;
}

.md-form-label + .md-layout-item .md-checkbox:not(:first-child),
.md-form-label + .md-layout-item + .md-layout-item .md-radio:not(:first-child),
.md-form-label + .md-layout-item .md-radio {
  margin-top: 0;
}

.form-control-static {
  margin-top: 6px;
}
</style>
